<div class="sidebar__container">
  <div class="row logo__cell">
    <div class="col-12">
      <img
        src="https://www.festisite.com/static/partylogo/img/logos/maker/anonymous.png"
        class="organizations--logo"
        placement="right"
        ngbTooltip="I am Bootstrap Tooltip"
      />
    </div>
  </div>
  <div class="row logo__cell">
    <div class="col-12">
      <img
        src="https://content.sportslogos.net/logos/11/446/full/9789_kootenay_ice-primary-2018.png"
        class="organizations--logo"
      />
    </div>
  </div>

  <div class="add__new--organizations">
    <div class="row">
      <div class="col-12">
        <!-- <img
          src="https://d1nhio0ox7pgb.cloudfront.net/_img/v_collection_png/512x512/shadow/user_add.png"
          class="organizations--logo"
        /> -->

        <div class="organizations--logo">
          <span class="organizations__add"><span>+</span></span>
        </div>
      </div>
    </div>
  </div>
</div>
